export const SUGGESTER_STATE = 'suggester'

export const FETCH_SUGGESTIONS_REQUEST = 'FETCH_SUGGESTIONS_REQUEST'
export const FETCH_SUGGESTIONS_SUCCESS = 'FETCH_SUGGESTIONS_SUCCESS'
export const FETCH_SUGGESTIONS_FAILURE = 'FETCH_SUGGESTIONS_FAILURE'
export const RESET_SUGGESTIONS = 'RESET_SUGGESTIONS'

export const MARKETS_FEATURE_SEARCH_ENGINE = ['fr', 'es']
